import {
  REQUEST_PROFILE_SUCCESS,
  REQUEST_PROFILE_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { id: null, error: null };

export default function profile(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_PROFILE_SUCCESS:
      
      return {
        id: parseInt(action.payload.data.id, 10),
        error: null
      };
    case REQUEST_PROFILE_FAILURE:
      return {
        ...state,
        id: null,
        error: action.payload.message
      };
    default:
      return state;
  }
}
